<template>
  <div>
    <informasi-lainnya-desktop v-if="!isMobile" />
    <informasi-lainnya-mobile v-else />
  </div>
</template>
<script>
import InformasiLainnyaDesktop from "./Desktop/InformasiLainnya-Desktop.vue";
import InformasiLainnyaMobile from "./Mobile/InformasiLainnya-Mobile.vue";
export default {
  components: {
    InformasiLainnyaDesktop,
    InformasiLainnyaMobile,
  },
  computed: {
    isMobile() {
      if (window.innerWidth >= 500) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.Hero {
  width: 100%;
  margin-top: -80px;
  object-fit: contain;
}
.Hero-Text {
  width: 763px;
  height: 56px;
  margin: 101px 418px 0 419px;
  font-family: Sora;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
  position: absolute;
}
</style>
